import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import GalleryImg from "../assets/Img/Factory.png";
import axios from "axios";
import no_img from "../assets/Img/no-image.jpg";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";

const ImageWithFallback = ({ src }) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(no_img);
  };

  return <img src={imgSrc} alt="img" onError={handleError} />;
};

const GalleryList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      
      axios
        .get(
          `${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/all/gallery/category`
        )
        .then((res) => {

          setData(res.data);
       
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchData();
    window.scrollTo(0, 0);
  }, []);
    useEffect(() => {
      const handleLoading = async () => {
        setLoading(true); // Start loading
        window.scrollTo(0, 0);
  
        // Simulate loading for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
  
        setLoading(false); // Stop loading
      };
  
      handleLoading();
    }, []);

  return (
    <React.Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            ariaLabel="loading-content"
          />
        </div>
      ) : (
        <div>
          <HeaderMobile />
          <Breadcrumb heading={"Gallery"} bTitle={"Gallery"} />
          <Container>
            <Row className="galleryRow">
              <div className="sub-title text-animation">
                <h6>
                  Gallery
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                    height={6}
                    viewBox="0 0 50 6"
                  >
                    <path d="M50 3L45 0.113249V5.88675L50 3ZM0 3.5H45.5V2.5H0V3.5Z" />
                  </svg>
                </h6>
              </div>
              {data &&
                data.map((data) => (
                  <Col
                    xl={3}
                    lg={4}
                    md={6}
                    key={data._id}
                    style={{ paddingBottom: "25px" }}
                  >
                    <Link to={`/galleryDetails/${data._id}`}>
                      <Card className="galleryCard">

                        <ImageWithFallback
                          src={
                            data.GalleryImage
                              ? `${process.env.REACT_APP_GRIPHOLD_API_URL}/${data.GalleryImage}`
                              : no_img
                          }
                        />
                        <div className="galleryTitle">{data.Title}</div>
                      </Card>
                    </Link>
                  </Col>
                ))}
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  );
};

export default GalleryList;
